import { $fetch, $post, $put } from '@/services/axios';

export function add(data) {
  return $put(`company/translation`, data);
}

export function fetch(data) {
  return $fetch(`company/translations`, data);
}

export function validate(data) {
  return $post(`company/translation/validate`, data);
}

export function edit(data) {
  return $post(`company/translation/${data.id}`, data);
}
